@import '../../sass/base/variables';
@import '../../sass/helpers';
@import '../../sass/mixins/screen-reader';
@import '../../sass/mixins/type';

som-modal {
  @keyframes modalAnimated {
    0% {
      opacity: 0;
      transform: scale(0.7);
    }

    100% {
      opacity: 1;
      transform: scale(1);
    }
  }

  @keyframes overlayAnimated {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }

  *,
  ::after,
  ::before {
    box-sizing: border-box;
  }

  dialog {
    padding: unset;
    border: none;
  }

  .modal {
    border-radius: 2px;
    transition: all 0.3s;
    width: 100%;
    z-index: $modal-index;
    overflow-y: auto;
    position: fixed;
      animation-name: modalAnimated;
      animation-duration: 0.3s;

    &::backdrop {
      z-index: $panel-overlay-index;
      background: $overlay-background;
      backdrop-filter: blur(8px);
      width: 100%;
      height: 100%;
      transition: all 0.3s;
    }

    &[open]::backdrop {
      animation-name: overlayAnimated;
      animation-duration: 0.3s;
    }

    &:not([open]) {
      pointer-events: none;
      opacity: 0;
    }

    &:focus {
      outline: none;
      border: none;
    }

    &.modal-sm {
      max-width: 300px;
    }

    &.modal-md {
      max-width: 500px
    }

    &.modal-lg {
      max-width: 800px;
    }

    .close-button {
      position: sticky;
      right: .5rem;
      top: .5rem;
      z-index: 1;
      float: right;
      padding:0;
      background-color: transparent;
      border:0;
      border-radius: 50%;
      cursor: pointer;
      color: $navy;
      font-size: 1.5rem;
      transition: all 0.15s;

      &:hover, &.scrolling:hover, &.scrolling:focus-visible {
        background-color: $smoke;
        color: $black;
      }

      &:focus-visible, &.scrolling {
        outline: $focus-border-width solid $navy;
      }

      &:focus-visible {
        background-color: $smoke;
      }

      &.scrolling {
        background-color: $white;
      }
    }

    .modal-content {
      width: 100%;
      height: auto;

      .modal-content-flex {
        display: flex;
        flex: 1;
        flex-direction: column;
      }

      .title {
        @include text-type(2, 700);
      }


      .modal-body {
        max-height: 70vh;
        background: white;

        .modal-body-content {
          position: relative;
        }
      }
    }
  }

  .sr-only {
    @include sr-only();
  }

  // Mobile version
  @media (max-width: 767.98px) {
    &[open] {
      /* Making sure a dark line doesn't appear because of transition calculations */
      background-color: $white;
    }

    .modal {
      width: 100% !important;
      max-height: 100dvh;
      min-height: 100dvh;
      max-width: 100% !important;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      border: 0;
      border-radius: 0;

      .modal-content {
        border: 0;
        min-height: 100%;

        .modal-body {
          max-height: 100% !important;
        }
      }
    }
  }
}
